import axios, { AxiosError } from "axios"
import { handleError } from "../Helpers/ErrorHandler"
import { BikeRequestModel } from "../Models/BikeRequestModel";
import { MTB_PART_PICKER_API } from "../constants";


export const saveBikeRequestAPI = async (make: string, model: string, year: string, email: string) => {
    try {
        const data = await axios.post<BikeRequestModel>(MTB_PART_PICKER_API + "/BikeRequest", {
            make: make,
            model: model,
            year: year,
            email: email
        })

        return data;
    } catch (error) {
        handleError(error)
    }
};
